import React, { Suspense, lazy, useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  HashRouter
} from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { ConfigProvider, config } from './context/configContext';

// i18n
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from "moment";
import MomentUtils from '@date-io/moment';
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/pl";
import "moment/locale/fr";
import "moment/locale/en-gb";
import { SnackbarProvider } from 'notistack';

// Theming
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import {getTheme} from "./theming/theme";
import { createTheme } from '@material-ui/core/styles'

const HomePage = lazy(() => import('./pages/HomePage'));
const ReservationPage = lazy(() => import('./pages/reservation-page'));
const RecoverReservation = lazy(() => import('./pages/recover-reservation'));
const ResNotFound = lazy(() => import('./pages/reservation-not-found'));
const SearchByEmail = lazy(() => import('./pages/search-by-email'));
const Reservations = lazy(() => import('./pages/reservations'));
const SearchRes = lazy(() => import('./pages/search-reservation'));

function App() {

  
  // Theming
  //const createMuiThemeOptions = getTheme(config);

  // @ts-ignore
  const theme = createTheme( getTheme(config) );

  let defaultLang = 'en';

  const [locale, setLocale] = useState(defaultLang);
  const langs = ['it', 'en', 'de', 'fr', 'nl', 'pl'];
  // i18n

  useEffect( () => {
    const urlSplited = window.location.href.split('/');
    langs.map( (lang: string) => {
      if ( urlSplited.indexOf(lang) > - 1 ) {
        defaultLang = lang;
        setLocale(lang)
      }
    })
  })

  
  
  moment.locale(locale, {
    week: {
      dow: 1
    }
  });
  i18n.changeLanguage(locale);
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
        <I18nextProvider i18n={i18n}>
          <SnackbarProvider maxSnack={3}>
            <ConfigProvider value={config}>
            <HashRouter hashType={'hashbang'}>
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  <Route exact path="/" component={HomePage} />
                  <Route exact path="/de/test" component={HomePage} />
                  <Route exact path="/fr/test" component={HomePage} />
                  <Route exact path="/reservations" component={Reservations} />
                  <Route exact path="/reservations/:GuestNum" component={ReservationPage} />
                  <Route exact path="/recovery-reservation" component={RecoverReservation} />
                  <Route exact path="/reservation-not-found" component={ResNotFound} />
                  <Route exact path="/search-by-email" component={SearchByEmail} />
                  <Route exact path="/search-reservation" component={SearchRes} />
                  <Route path="*" component={ResNotFound} />
                </Switch>
              </Suspense>
            </HashRouter>
            </ConfigProvider>
          </SnackbarProvider>
        </I18nextProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}

export default App;
